import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { Col, DatePicker, Form, Modal, Row } from 'antd';
import { useDefaultEmptyFieldError } from '@/hooks';
import {
  useSpedDocumentCreate,
  useSpedDocumentEdit,
} from '@/core/domain/sped/sped-documents/sped-documents.hooks';
import moment, { Moment } from 'moment';
import {
  SpedDocument,
  SpedDocumentAssessmentMonth,
} from '@/core/domain/sped/sped-documents/sped-documents.types';
import { useEffect } from 'react';

interface Props {
  opened: boolean;
  onClose: VoidFunction;
  spedDocument?: SpedDocument;
}

interface FormValues {
  companyId: number;
  period: Moment;
}

export default function SpedDocumentModal(props: Props) {
  const fieldRequired = useDefaultEmptyFieldError();

  const spedDocumentCreate = useSpedDocumentCreate();
  const spedDocumentEdit = useSpedDocumentEdit();
  const isLoading = spedDocumentCreate.isLoading;

  const isEdit = !!props.spedDocument;

  const [form] = Form.useForm<FormValues>();

  useEffect(() => {
    if (props.spedDocument) {
      const spedDocument = props.spedDocument;

      form.setFieldsValue({
        companyId: spedDocument.companyId,
        period: moment([
          Number(spedDocument.assessmentYear),
          Number(spedDocument.assessmentMonth) - 1,
          1,
        ]),
      });
    }
  }, [props.spedDocument]);

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (props.spedDocument) {
        await spedDocumentEdit.mutateAsync({
          spedDocumentId: props.spedDocument.id,
          companyId: values.companyId,
          assessmentMonth: values.period.format(
            'MM',
          ) as SpedDocumentAssessmentMonth,
          assessmentYear: values.period.format('YYYY'),
        });
      } else {
        await spedDocumentCreate.mutateAsync({
          companyId: values.companyId,
          assessmentMonth: values.period.format(
            'MM',
          ) as SpedDocumentAssessmentMonth,
          assessmentYear: values.period.format('YYYY'),
        });
      }
      handleClose();
    } catch {}
  };

  return (
    <Modal
      open={props.opened}
      onCancel={handleClose}
      title={isEdit ? 'Editar documento SPED' : 'Cadastrar novo documento SPED'}
      okText="Salvar"
      onOk={handleSubmit}
      confirmLoading={isLoading}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <Form form={form}>
        <Row>
          <Col span={24}>
            <FloatingFormItem
              name="companyId"
              label="Empresa"
              rules={[fieldRequired]}
            >
              <CompaniesInfiniteSelectField
                disabled={isLoading}
                queryEnable={props.opened}
                queryFilter={{ filterActiveSped: true }}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="period"
              label="Período (Mês/Ano)"
              rules={[fieldRequired]}
            >
              <DatePicker
                picker="month"
                format="MMMM/YYYY"
                placeholder=""
                style={{ width: '100%' }}
                disabled={isLoading}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
